module.exports = __webpack_public_path__ + "static/img/klp1260-663-370gld.d7d65ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/klp1260-663-370gld.jpg
// module id = EROB
// module chunks = 0